import apiClient from './apiClient';

export const usersApi = {
	getAll: async (orgId) => {
		try {
			const response = await apiClient.get(
				`/api/organizations/${orgId}/users`
			);
			return response.data;
		} catch (error) {
			console.error('API Error:', {
				status: error.response?.status,
				data: error.response?.data,
				headers: error.response?.headers,
			});

			throw new Error(
				error.response?.data?.message ||
					`Failed to fetch users (Status: ${error.response?.status})`
			);
		}
	},

	getOne: async (id) => {
		try {
			const response = await apiClient.get(`/api/users/${id}`);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch user'
			);
		}
	},

	update: async (userId, data) => {
		try {
			const response = await apiClient.patch(
				`/api/users/${userId}`,
				data
			);
			return response.data;
		} catch (error) {
			console.error('Update error:', error.response || error);
			throw new Error(
				error.response?.data?.message ||
					`Failed to update user: ${error.message}`
			);
		}
	},

	removeFromOrganization: async (orgId, userId) => {
		try {
			const response = await apiClient.delete(
				`/api/organizations/${orgId}/users/${userId}`
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message ||
					'Failed to remove user from organization'
			);
		}
	},

	updateTeamUserStatus: async (teamId, userId, isActive) => {
		try {
			const response = await apiClient.patch(
				`/api/teams/${teamId}/users/${userId}/status`,
				{ isActive }
			);

			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to update user status'
			);
		}
	},

	getAllAdmin: async () => {
		try {
			const response = await apiClient.get(`/api/users/admin`);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch users'
			);
		}
	},

	createAdmin: async (userData) => {
		try {
			const response = await apiClient.post(`/api/users/admin-create`, {
				firstName: userData.firstName,
				lastName: userData.lastName,
				email: userData.email,
				password: userData.password,
				phoneNumber: userData.phoneNumber,
				userPhoto: userData.userPhoto,
				accessLevel: userData.accessLevel || 'User',
			});
			return response.data;
		} catch (error) {
			if (error.response?.status === 403) {
				throw new Error('Only administrators can create users');
			}
			throw new Error(
				error.response?.data?.message || 'Failed to create user account'
			);
		}
	},
	usersByEmail: {
		search: async (email) => {
			try {
				const response = await apiClient.get(
					`/api/users/search?email=${encodeURIComponent(email)}`
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to search users'
				);
			}
		},
	},

	// Send password reset email
	sendPasswordResetEmail: async (email) => {
		try {
			const response = await apiClient.post(
				'/api/users/forgot-password',
				{ email }
			);
			return response.data;
		} catch (error) {
			throw error.response?.data || error;
		}
	},

	// Reset password with code
	resetPassword: async (email, code, newPassword) => {
		try {
			const response = await apiClient.post('/api/users/reset-password', {
				email,
				code,
				newPassword,
			});
			return response.data;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
};
